import React from "react";
import { api } from "../../api/api";
import { ILead } from "../../redux/leads/leads.types";
import { useBillingCompanyContext } from "../../providers";
import { useDispatchWrapper } from "../../hooks";
import { BookingDetailsDisplay } from "../dashboard/Dashboard/components/ViewLeadDeatils/BookingDetailsDisplay";
import {
  saveLoaderProgress,
  saveLoaderCompleted,
} from "../../redux/messages/messagesActions";

interface IViewOcccupancyRightPanelProps {
  open: boolean;
  id: string;
  onClose: () => void;
}

export interface Booking {
  booking_id: number;
  booking_uuid: string;
  capacity: number;
  create_ts: string;
  created_by_name: string;
  created_by_uuid: string;
  customer_email: string;
  customer_fact_uuid: string;
  customer_mobile_no: string;
  customer_name: string;
  event_time: string;
  food_menu: string | null;
  from_date: string;
  insert_ts: string;
  leads_uuid: string;
  modified_by_name: string;
  modified_by_uuid: string;
  occupancy_uuid: string;
  shift_time: string;
  status: string;
  to_date: string;
  total_guest: number;
  total_price: number;
  user_uuid: string;
  venue_name: string;
  venue_uuid: string;
}

export const ViewOccupancyRightPanel: React.FC<
  IViewOcccupancyRightPanelProps
> = (props) => {
  const { open, id, onClose } = props;

  const companyOutlet = useBillingCompanyContext();
  const dispatch = useDispatchWrapper();

  const [openEdit, setOpenEdit] = React.useState<ILead | null>(null);
  const [data, setData] = React.useState<Booking>({
    booking_id: 0,
    booking_uuid: "",
    capacity: 0,
    create_ts: "",
    created_by_name: "",
    created_by_uuid: "",
    customer_email: "",
    customer_fact_uuid: "",
    customer_mobile_no: "",
    customer_name: "",
    event_time: "",
    food_menu: null,
    from_date: "",
    insert_ts: "",
    leads_uuid: "",
    modified_by_name: "",
    modified_by_uuid: "",
    occupancy_uuid: "",
    shift_time: "",
    status: "",
    to_date: "",
    total_guest: 0,
    total_price: 0,
    user_uuid: "",
    venue_name: "",
    venue_uuid: "",
  });

  // Handler for completing edit
  const handleEditComplete = () => {
    setOpenEdit(null);
  };

  React.useEffect(() => {
    if (open && id) {
      dispatch(saveLoaderProgress());
      (async () => {
        try {
          const res = await api.get(
            `/occupancy/get-booking?occupancy_uuid=${id}&pageNo=1&itemPerPage=1&pageLimit=1&upcoming_bookings=false`,
          );
          const responseData = res.data.data;
          if (responseData.length > 0) {
            setData(responseData[0]);
          }
          dispatch(saveLoaderCompleted());
        } catch (error) {
          dispatch(saveLoaderCompleted());
        }
      })();
    }
  }, [open, id, dispatch]);

  // React.useEffect(() => {
  //   if (data.leads_uuid) {
  //     dispatch(
  //       fetchLeadAsync({
  //         leadId: data.leads_uuid,
  //         company_outlet_uuid: companyOutlet.comapny.company_outlet_uuid,
  //         multiple_events: 0,
  //         skipLoader: true,
  //         onCallBack: (lead, isSuccess) => {
  //           if (isSuccess) {
  //             setOpenEdit(lead);
  //           }
  //         },
  //       })
  //     );
  //   }
  // }, [data, dispatch, companyOutlet.comapny.company_outlet_uuid]);
  return (
    <>
      {data.leads_uuid && open && (
        <BookingDetailsDisplay open={true} data={data} onClose={onClose} />
      )}
    </>
  );
};
